import React from 'react'
import Fab from '@material-ui/core/Fab'
import icons from '@nocode-works/template/icons'
import NavDrawer from 'components/widgets/NavDrawer'
import MenuList from 'components/widgets/MenuList'

const SettingsIcon = icons.settings

const AppBarMenu = ({
  items,
}) => {

  const getButton = (onClick) => {
    return (
      <Fab
        size="medium"
        color="secondary"
        onClick={ onClick }
      >
        <SettingsIcon />
      </Fab>
    )
  }

  return (
    <NavDrawer
      anchor="right"
      Component={ MenuList }
      getButton={ getButton }
      props={{
        items,
      }}
    />
  )
}

export default AppBarMenu